'use client';

import { useState, useCallback } from 'react';
import { adminKycApi } from '../api';
import { DocumentReviewResponse } from '../types';

interface UseApproveDocumentReturn {
  approve: (documentId: string, tenantSlug: string, adminUserId?: string) => Promise<DocumentReviewResponse>;
  isLoading: boolean;
  error: string | null;
  data: DocumentReviewResponse | null;
  reset: () => void;
}

export function useApproveDocument(): UseApproveDocumentReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<DocumentReviewResponse | null>(null);

  const approve = useCallback(
    async (documentId: string, tenantSlug: string, adminUserId?: string) => {
      setIsLoading(true);
      setError(null);
      setData(null);
      try {
        const response = await adminKycApi.approveDocument(documentId, tenantSlug, adminUserId);
        setData(response);
        return response;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to approve document';
        setError(errorMessage);
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  const reset = useCallback(() => {
    setIsLoading(false);
    setError(null);
    setData(null);
  }, []);

  return { isLoading, error, data, approve, reset };
}
